import classNames from 'classnames/bind';
import styles from './Table.module.css';
import TableBody from '../../../components/TableBody';
import { CONTENT, DATE, DELETE, REGISTRATION } from '../../../constants';
import {
  FaqItem,
  FeedbackItem,
  ShareLink,
  NoticeItem,
  RegistrationRequest,
} from '../../../types/settings';

import { useAppDispatch, useAppSelector } from '../../../hooks/useRedux';
import {
  reqPageChanged,
  reqSortDirChanged,
  selectReqSortDir,
  selectShareLinkSortDir,
  shareLinkPageChanged,
  shareLinkSortDirChanged,
} from '../../../features/settingsSlice';

interface Table {
  name: string;
  list:
    | ShareLink[]
    | NoticeItem[]
    | FaqItem[]
    | FeedbackItem[]
    | RegistrationRequest[];
}

export default function Table({ name, list }: Table) {
  const cx = classNames.bind(styles);
  const dispatch = useAppDispatch();

  const shareLinkSortDir = useAppSelector(selectShareLinkSortDir);
  const reqSortDir = useAppSelector(selectReqSortDir);

  const sortList = () => {
    if (name === 'sharedLink') {
      dispatch(
        shareLinkSortDirChanged(shareLinkSortDir === 'DESC' ? 'ASC' : 'DESC')
      );
      dispatch(shareLinkPageChanged(0));
    } else if (name === 'studentRegistration') {
      dispatch(reqSortDirChanged(reqSortDir === 'DESC' ? 'ASC' : 'DESC'));
      dispatch(reqPageChanged(0));
    }
  };

  return (
    <>
      <div className={cx('table_list', 'table_head', 'board_head', 'st_share')}>
        <div className={cx('items', 'option_order')}>
          <span className={cx('is_order')}>
            <span className={cx('btn', 'open_order_menu')}>{DATE}</span>
            <span
              className={cx('btn', 'order_arrow', reqSortDir)}
              onClick={sortList}
            ></span>
          </span>
        </div>
        <div className={cx('items', 'tac')}>
          <span>{CONTENT}</span>
        </div>
        <div className={cx('items')}>
          <span className={cx('blind')}>{REGISTRATION}</span>
        </div>
        <div className={cx('items')}>
          <span className={cx('blind')}>{DELETE}</span>
        </div>
      </div>

      <TableBody name={name} list={list} />
    </>
  );
}
